import React from "react";
import { motion } from "framer-motion";
import SectionShell from "./SectionShell";

const STEPS = [
  {
    stage: "Protect",
    title: "Your family, first.",
    body: "The floor beneath your plan. Right amount, right kind, right price, for what your household actually needs today.",
  },
  {
    stage: "Recover",
    title: "Get your premiums back.",
    body: "Money Back Life™: permanent coverage where you pay for a limited number of years and receive the value of your premiums back. Not gone, not gambled.",
  },
  {
    stage: "Prosper",
    title: "Turn coverage into an asset.",
    body: "Prosperity Life™: tax-advantaged wealth accumulation and tax-efficient retirement income. Your insurance quietly compounds while it protects.",
  },
];

export default function Method() {
  return (
    <SectionShell
      id="method"
      eyebrow="The Prospera Method"
      title="Protection · Recovery · Prosperity."
      intro="A single three-stage framework that turns life insurance from a monthly expense into a financial asset you actually benefit from, while you're still living."
      variant="elevated"
      data-testid="method"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E6E2D8] rounded-2xl overflow-hidden border border-[#E6E2D8]">
        {STEPS.map((s, i) => (
          <motion.article
            key={s.stage}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.32, 0.72, 0, 1] }}
            className="group bg-white p-8 md:p-10 transition-colors duration-300 hover:bg-[#FCFBF8]"
            data-testid={`method-${s.stage.toLowerCase()}`}
          >
            <div className="flex items-baseline justify-between">
              <span className="text-[11px] tracking-[0.3em] uppercase font-semibold text-[#8A6A2E]">
                {s.stage}
              </span>
              <span className="font-display italic text-4xl text-[#E6E2D8] group-hover:text-[#B08D57] transition-colors duration-500">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <h3 className="font-display text-[#0B1F3F] text-2xl md:text-[28px] leading-tight mt-10">
              {s.title}
            </h3>
            <p className="text-[#5A6476] text-[15px] leading-relaxed mt-4">{s.body}</p>
          </motion.article>
        ))}
      </div>
    </SectionShell>
  );
}
